const { IComponentSetup } = require("./shared/s-component-setup");

jQuery( document ).ready( function( $ )
{
	IComponentSetup.setupGlobalComponentsObj();
});
